<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full sm:w-auto ">
                    <label class="vs-input--label">{{this.$t('overTime.branch')}}</label>
                    <span class="text-danger">*</span>
                    <v-select class="" :disabled="isUpdate || userInfo.userRole != 'organization'" v-model="selectedOrganizationBranch"
                                :clearable="false" :options="organizationBranchOptions">
                        <span slot="no-options">{{$t('menuOrganization.emptyList')}}</span>
                    </v-select>
                </div>

                <div class="vx-col md:w-1/2 w-full">
                    <label class="vs-input--label">{{this.$t('overTime.employee')}}</label>
                    <span class="text-danger">*</span>
                    <v-select v-validate="'required'" class="" v-model="selectedEmployee" :clearable="false" :options="employeeOptions" :disabled="isUpdate" name="employeeCode">
                        <span slot="no-options">{{$t('menuOrganization.emptyList')}}</span>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('employeeCode') }}</span>
                </div>
            </div>

            <div class="vx-row mt-2">
                <div :class="{'vx-col md:w-1/3 w-full mt-2' : isUpdate , 'vx-col md:w-1/2 w-full mt-2' : !isUpdate}">
                    <label class="vs-input--label">{{this.$t('overTime.beginDate')}}</label>
                    <span class="text-danger">*</span>
                    <datepicker :disabled="isUpdate" :disabledDates="disabledFn" :highlighted="highlighted" :language="languages['vi']" :format="'dd/MM/yyyy'" v-model="overtime.fromTime"
                                data-vv-validate-on="input" v-validate="'required'" name="expiredDate"></datepicker>
                    <span class="text-danger text-sm">{{ errors.first('expiredDate') }}</span>
                </div>
                <div :class="{'vx-col md:w-1/6 mt-2 w-full' : isUpdate, 'vx-col md:w-1/2 mt-2 w-full' : !isUpdate}">
                    <label class="vs-input--label">{{this.$t('overTime.startTime')}}</label>
                    <span class="text-danger">*</span>
                    <v-select :value="overtime.fromHourString" :disabled="isUpdate" :clearable="false"
                                :options="timeSpans"
                                @input="fromHour => updateTimeSpan(overtime, fromHour, 'fromHour')" name="fromHour"
                                v-validate="'required'">
                        <span slot="no-options">{{$t('menuOrganization.emptyList')}}</span>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('fromHour') }}</span>
                </div>

                <div :class="{'vx-col md:w-1/3 w-full mt-2' : isUpdate , 'vx-col md:w-1/2 w-full mt-2' : !isUpdate}">
                    <label class="vs-input--label">{{this.$t('overTime.endDayWork')}}</label>
                    <span class="text-danger">*</span>
                    <datepicker :disabled="isUpdate" :disabledDates="disabledFn" :highlighted="highlighted" :language="languages['vi']" :format="'dd/MM/yyyy'" v-model="overtime.toTime"
                                data-vv-validate-on="input" v-validate="'required'" name="expiredDate"></datepicker>
                    <span class="text-danger text-sm">{{ errors.first('expiredDate') }}</span>
                </div>
                <div :class="{'vx-col md:w-1/6 mt-2 w-full' : isUpdate, 'vx-col md:w-1/2 mt-2 w-full' : !isUpdate}">
                    <label class="vs-input--label">{{this.$t('overTime.endTime')}}</label>
                    <span class="text-danger">*</span>
                    <v-select :value="overtime.toHourString" :disabled="isUpdate" :clearable="false"
                                :options="timeSpans"
                                @input="toHour => updateTimeSpan(overtime, toHour, 'toHour')" name="toHour"
                                v-validate="'required'">
                        <span slot="no-options">{{$t('menuOrganization.emptyList')}}</span>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('toHour') }}</span>
                </div>
            </div>

            <div class="vx-row mt-2">
                <div :class="{'vx-col md:w-1/2 w-full' : isUpdate, 'vx-col w-full' : !isUpdate}">
                    <label class="vs-input--label">{{this.$t('overTime.reseon')}}</label>
                    <span class="text-danger">*</span>
                    <vs-textarea class="w-full" :disabled="isUpdate"
                                    v-model="overtime.reason"
                                    name="reason"
                                    v-validate="'required'"
                                    />
                    <span class="text-danger text-sm">{{ errors.first('reason') }}</span>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="isUpdate">
                    <label class="vs-input--label">{{this.$t('overTime.status')}}</label>
                    <v-select  :disabled="!(isUpdate && isAbleUpdate || !isUpdate ) " class="" v-model="overtimeStatusModel" :clearable="false" :options="overtimeStatusOptions.filter(el => el.value != statusOvertime && el.value != 0)">
                        <span slot="no-options">{{$t('menuOrganization.emptyList')}}</span>
                    </v-select>
                </div>
            </div>

             <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="flex flex-wrap items-center justify-end mb-2 mt-2">
                        <vs-button v-if="(isAbleUpdate && isUpdate) || !isUpdate" class="ml-auto mt-2" @click="saveChanges"
                                    :disabled="!validateForm || !employeeOptions.length "   >{{
                                `${isUpdate ?
                                    $t('button.update') : $t('button.create')}`
                            }}
                        </vs-button>
                        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="comeBack">{{ $t('button.back') }}
                        </vs-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as lang from 'vuejs-datepicker/src/locale';
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select'
import moment from 'moment'
import utils from "../../../components/utils";
export default {
    components: {
        Datepicker,
        vSelect
    },
    data(){
        return {
            listBranchs: [],
            timeSpans: [],
            highlighted : {
                dates: [
                    new Date()
                ]
            },
            isUpdate: false,
            isAbleUpdate: true,
            userInfo: {},
            overtime: {
                status: null,
                organizationBranchId: null,
                employeeId: null
            },
            languages: lang,

            //list branch
            organizationBranchOptions: [],

            //employee
            employeeOptions: [],
            selectedEmployeeValue: null,

            //overtime
            overtimeStatusOptions: [
                {value: 0, label: this.$t('overTime.wait')},
                {value: 1, label: this.$t('overTime.approved')},
                {value: 2, label: this.$t('statusActive.decline')},
                // {value: 3, label: 'Hủy bỏ'}
            ],

            //info
            statusOvertime: null,
            organizationBranchId: null,
            employeeId: null,
            disabledFn: {
                customPredictor(date) {
                    if (moment(date).isBefore(moment(), 'days')) {
                        return true;
                    }
                }
            }
        }
    },
    computed: {
        overtimeStatusModel: {
            get() {
                let object = this.overtimeStatusOptions.find(el => el.value === this.overtime.status);
                return {
                    label: object ? object.label : this.$t('menuOrganization.null'),
                    value: this.overtime.status
                }
            },
            set(obj) {
                this.overtime.status = obj.value;
            }
        },
        validateForm() {
            return !this.errors.any()
        },

        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.overtime.organizationBranchId),
                    value: this.overtime.organizationBranchId
                }
            },
            set(obj) {
                this.overtime.organizationBranchId = obj.value
                this.loadEmployee();
            }
        },

        selectedEmployee: {
            get() {
                return {
                    label: this.employeeString(this.overtime.employeeId),
                    value: this.overtime.employeeId
                }
            },
            set(obj) {
                this.overtime.employeeId = obj.value
                this.loadEmployee();
            }
        }
    },
    methods: {
        updateTimeSpan(setting, hour, type) {

            setting[type] = hour.value;
            setting[`${type}String`] = hour.label;
        },
        comeBack(){
            this.$router.push(`/user/over-time-manager`).catch(() => {
            })
        },
        async saveChanges(){
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;
            if (this.overtime.fromHour > this.overtime.toHour || this.overtime.fromTime > this.overtime.toTime || (!this.overtime.fromTime || !this.overtime.toTime)) {
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: 'Thời gian ca làm thêm không hợp lệ',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if (!this.isUpdate){
                this.overtime.fromTime = new Date(this.overtime.fromTime.setHours(0, this.overtime.fromHour, 0, 0));
                this.overtime.toTime = new Date(this.overtime.toTime.setHours(0, this.overtime.toHour, 0, 0));
            }
            let checkEmployee = true;
            if (!this.overtime.employeeId) {
                checkEmployee = false;
                return this.$vs.notify({
                    text: 'Chưa chọn nhân viên',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }
            if (!checkEmployee) return;
            this.$vs.loading();
            const patch = this.isUpdate ? 'over-time/update' : 'over-time/admin-assign';
            this.$crm.post(patch, this.overtime).then(() => {
                this.$vs.loading.close();
                this.isUpdate = true;
                this.$router.push('/user/over-time-manager')
                return this.$vs.notify({
                    text: this.isUpdate ? 'Cập nhật ca làm thêm thành công' : 'Thêm mới ca làm thêm thành công',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success'
                })
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },
        employeeString(id) {
            let employee = this.employeeOptions.find(x => x.value == id);
            return (employee && employee.label) || this.$t('menuOrganization.null');
        },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || this.$t('menuOrganization.null');
        },
        initScreen(){
            let timeDuration = 30, timeSpans = [];
            for (let i = 0; i < 24 * 60; i = i + timeDuration) {
                timeSpans.push({value: i, label: utils.minuteToHour(i)});
            }
            this.timeSpans = timeSpans;
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            this.userInfo = userInfo;
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]')
            if (branchList.length == 0) {
                return this.$vs.notify({
                    text: 'Hiện tại không tồn tại chi nhánh nào',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.map(item => {
                return {value: item.id, label: item.organizationBranchName}
            })
            if (userInfo.userRole == 'organizationBranch') {
                this.organizationBranchOptions = this.organizationBranchOptions.filter(el => el.value == userInfo.organizationBranchId);
            }
            let branchId = this.$route.query.branch_id;
            let index = 0;
            let overtimeId = this.$route.query.id;
            if (overtimeId) this.findByOrganizationBranchId(overtimeId);
            if (branchId) {
                index = this.organizationBranchOptions.findIndex(item => item.value == branchId)
            }
            this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];
            this.loadEmployee();
        },
        findByOrganizationBranchId: function(organizationBranchId){
            this.$crm.get(`over-time/org/find-by-id/${organizationBranchId}`).then((res) => {
                this.overtime = res.data;
                if(res.data.status == 0){
                    this.isAbleUpdate = true;
                }else {
                    this.isAbleUpdate = false;
                }
                if(res.data.status == 3){
                    this.overtimeStatusOptions = [
                        {value: 0, label: 'Chờ'},
                        {value: 1, label: 'Đã duyệt'},
                        {value: 2, label: 'Từ chối'},
                        {value: 3, label: 'Đã hủy'},
                    ]
                }
                this.overtime.fromHourString = new Date(res.data.fromTime).getHours() + ":" + new Date(res.data.fromTime).getMinutes();
                this.overtime.fromHour = new Date(res.data.startHour).getMinutes() * 60 + new Date(res.data.startHour).getMinutes();
                this.overtime.toHourString = new Date(res.data.toTime).getHours() + ":" + new Date(res.data.toTime).getMinutes();
                this.overtime.toHour = new Date(res.data.endHour).getMinutes() * 60 + new Date(res.data.endHour).getMinutes();
                this.isUpdate = true;
            })
        },
        loadEmployee() {
            this.$vs.loading();
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            let branchId = this.overtime.organizationBranchId ? this.overtime.organizationBranchId : userInfo.employeeId;
            let path = this.overtime.organizationBranchId ? `/employee/find-by-organization-branch/${branchId}?isEnabled=true` : '/employee/find-by-organization-branch'
            this.$crm.post(path).then((response) => {
                this.employeeData = response.data;
                this.employeeOptions = response.data.map(item => {
                    return {
                        value: item.employeeId,
                        label: item.employeeCode + " " + item.fullName,
                        ...item
                    }
                });
                // this.overtime.employeeId = this.employeeOptions[0].value;
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
    },
    async created(){
        let check = false;
        this.$eventBus.$on("notify-detail-overtime", ($event) => {
            if ($event) this.initScreen();
            check = true;
        })
        if (!check) this.initScreen();
    },
    mounted(){
        this.$eventBus.$on("notify-detail-overtime", ($event) => {
            this.initScreen();
        })
    }
}
</script>

<style>

</style>
